import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { PDFExport } from '@progress/kendo-react-pdf';
import ActionButton from './ActionButton';
import FollowUp from './FollowUp';

const InquiryTable = React.forwardRef(({ data, sortData, setData, onDelete, isDetails, setIsDetails, searchTerm }, ref) => {
    const [order, setOrder] = useState('asc');
    const [filterResult, setFilterResult] = useState([]);

    const onSort = (col) => {
        if (order === 'asc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] > b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('desc');
        }
        if (order === 'desc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] < b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('asc');
        }
    };

    useEffect(() => {
        const filtered = data.filter(data => data.member.toLowerCase().includes(searchTerm.toLowerCase()) || data.consultant.toLowerCase().includes(searchTerm.toLowerCase()) || data.pkg.toLowerCase().includes(searchTerm.toLowerCase()) || data.status.toLowerCase().includes(searchTerm.toLowerCase()) || data.mobile.toString().toLowerCase().includes(searchTerm.toLowerCase()));

        setFilterResult(filtered);
    }, [searchTerm, data])


    return (
        <div className="flex flex-col">
            <div className="overflow-x-auto mx-2">
                <div className=" pt-8 lg:py-2 inline-block min-w-full px-2 sm:px-4 lg:px-6">
                    <div className="overflow-hidden">
                        <PDFExport paperSize="A4" fileName="dashboard" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                            <table className="min-w-full border text-center" id='table-to-xls'>
                                <thead className="border-b">
                                    <tr>
                                        <th scope="col" className="table_head" onClick={() => onSort('Sno')}>
                                            Sno<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('member')}>
                                            Member Name<i className="fa-solid fa-sort ml-2 text-xs opacity-50" ></i>
                                        </th>
                                        <th scope="col" className="table_head " onClick={() => onSort('mobile')}>
                                            Mobile No.<i className="fa-solid fa-sort ml-2 text-xs opacity-50" ></i>
                                        </th>
                                        <th scope="col" className="table_head " onClick={() => onSort('consultant')}>
                                            Consultant Name<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head " onClick={() => onSort('pkg')}>
                                            package<i className="fa-solid fa-sort ml-2 text-xs opacity-50" ></i>
                                        </th>
                                        <th scope="col" className="table_head " onClick={() => onSort('fee')}>
                                            Fee<i className="fa-solid fa-sort ml-2 text-xs opacity-50" ></i>
                                        </th>
                                        <th scope="col" className="table_head " onClick={() => onSort('date')}>
                                            Enquiry Date<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('status')}>
                                            Enquiry Status<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('fDate')}>
                                            Followup Date<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head ">
                                            Follow-Up
                                        </th>
                                        <th scope="col" className="table_head ">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                {filterResult.length > 0 ? (filterResult.map((item, index) => <tbody key={index}>
                                    <tr className="border-b hover:bg-gray-100 animation">
                                        <td className="table_body border-r">
                                            {item.Sno}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.member}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.mobile}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.consultant}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.pkg}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.fee}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.date}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.status}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.fDate}
                                        </td>
                                        <td className="table_body border-r">
                                            <FollowUp isDetails={isDetails} setIsDetails={setIsDetails} />
                                        </td>
                                        <td className="table_body border-r">
                                            <div className='flex items-center justify-center flex-wrap sm:flex-nowrap gap-2'>
                                                <Link to="/admin/enquiry/edit" className='link bg-blue-600 text-white h-7 w-7 leading-7 rounded-sm text-center cursor-pointer hover:bg-blue-700 animation'>
                                                    <i className="fa-regular fa-pen-to-square"></i>
                                                </Link>
                                                <button className='bg-red-500 text-white h-7 w-7 rounded-sm text-center cursor-pointer leading-7 hover:bg-red-500 animation' onClick={() => onDelete(item)}>
                                                    <i className="fa-regular fa-trash-can"></i>
                                                </button>
                                                <ActionButton />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>)) : <tbody><tr><td colSpan="100%" className='py-3 text-sm text-gray-800'>No Data Available</td></tr></tbody>}
                            </table>
                        </PDFExport>
                    </div>
                </div>
            </div>
        </div>
    )
});

export default InquiryTable;